/**
 * Normalize line endings (\r\n and \r to \n) recursively in objects/arrays/strings.
 */
export const normalizeLineEndings = <T>(value: T): T => {
    if (typeof value === 'string') {
        return value.replace(/\r\n/g, '\n').replace(/\r/g, '\n') as T;
    }
    if (Array.isArray(value)) {
        return value.map(normalizeLineEndings) as T;
    }
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, normalizeLineEndings(v)])) as T;
    }
    return value;
};
